// ─── Constantes partagées ─────────────────────────────────────────────────────
export const STATUSES = ["En attente", "Collecté", "En traitement", "Prêt", "Livré"];
export const STATUSES_SUR_PLACE = ["Réceptionné", "En traitement", "Prêt", "Récupéré"];
// Couleurs de statut — teintes sobres alignées sur theme.js (STATUS).
export const STATUS_COLORS = {
  "En attente":    "#a16207",
  "Réceptionné":   "#b45309",
  "Collecté":      "#1d4ed8",
  "En traitement": "#6d28d9",
  "Prêt":          "#15803d",
  "Livré":         "#0a2540",
  "Récupéré":      "#15803d",
};

// ─── Alias de compatibilité ───────────────────────────────────────────────────
// Conservés pour l'existant ; toute nouvelle UI doit importer les tokens
// depuis theme.js (C, R, SH, F) plutôt que ces constantes.
export const BLUE       = "#0a2540";  // marine profond (couleur principale)
export const DARK_BLUE  = "#071b30";  // titres, survol
export const LIGHT_BLUE = "#15803d";
export const GREEN      = "#15803d";

// Les icônes sont désormais des noms sémantiques résolus par src/icons.js.
// Valeurs de repli : n'apparaissent que si l'API est injoignable — les vrais
// services viennent de la base. Icônes choisies par TYPE DE TRAITEMENT pour
// rester distinctes les unes des autres.
export const SERVICES = [
  { icon: "iron",    label: "Chemises & Costumes" },
  { icon: "garment", label: "Robes & Vêtements" },
  { icon: "bed",     label: "Linge de maison" },
  { icon: "clean",   label: "Manteaux & Vestes" },
];

export const TESTIMONIALS = [
  { name: "Fatou Diallo",   text: "Service impeccable ! Mes vêtements sont rendus propres et bien repassés. Je recommande vivement.", stars: 5 },
  { name: "Moussa Sow",     text: "Rapide, efficace et professionnel. Le suivi en ligne est très pratique.", stars: 5 },
  { name: "Aissatou Balde", text: "Excellent pressing à Dakar. Prix raisonnables et qualité au rendez-vous !", stars: 5 },
];

export const CLOTHES_TYPES = [
  "Chemise", "Pantalon", "Robe", "Costume", "Veste", "Manteau",
  "T-shirt", "Jupe", "Pullover", "Jean", "Linge de lit", "Autre",
];

export const WA_SENDER = "221705072332";

// ─── Admin/Manager constants ──────────────────────────────────────────────────
export const ROLE_LABELS = { admin: "Admin", manager: "Manager", collector: "Collecteur" };
export const ROLE_COLORS = { admin: "#b91c1c", manager: "#1d4ed8", collector: "#15803d" };
export const ROLE_ICONS  = { admin: "shield", manager: "userCheck", collector: "collect" };

export const MANAGER_PERMISSIONS = [
  { key: "can_create_orders",    label: "Créer des commandes" },
  { key: "can_edit_orders",      label: "Modifier les commandes" },
  { key: "can_change_status",    label: "Changer les statuts" },
  { key: "can_view_finances",    label: "Voir les finances" },
  { key: "can_manage_articles",  label: "Gérer les articles" },
  { key: "can_manage_services",  label: "Gérer les services" },
  { key: "can_manage_pricing",   label: "Gérer les tarifs" },
  { key: "can_manage_promos",    label: "Gérer les promotions" },
  { key: "can_view_reviews",     label: "Voir les avis" },
  { key: "can_send_whatsapp",    label: "Envoyer WhatsApp" },
];
export const DEFAULT_PERMISSIONS = Object.fromEntries(MANAGER_PERMISSIONS.map(p => [p.key, true]));
export const FULL_PERMISSIONS = { ...DEFAULT_PERMISSIONS };

export function getPermissions(user) {
  if (!user) return DEFAULT_PERMISSIONS;
  if (user.role === "admin") return FULL_PERMISSIONS;
  if (user.permissions) return { ...DEFAULT_PERMISSIONS, ...user.permissions };
  return DEFAULT_PERMISSIONS;
}

export const PERMISSION_PRESETS = {
  full: { label: "Accès complet", perms: { ...FULL_PERMISSIONS } },
  limited: { label: "Accès limité", perms: Object.fromEntries(MANAGER_PERMISSIONS.map(p => [p.key, ["can_create_orders", "can_edit_orders", "can_change_status"].includes(p.key)])) },
  readonly: { label: "Lecture seule", perms: Object.fromEntries(MANAGER_PERMISSIONS.map(p => [p.key, false])) },
};

export const GOLD = "#d97706";
export const CHART_COLORS = ["#0a2540", "#1d4ed8", "#d97706", "#15803d", "#6d28d9", "#b91c1c", "#0e7490", "#a16207"];
export const MONTHS_FR = ["Jan", "Fév", "Mar", "Avr", "Mai", "Jun", "Jul", "Aoû", "Sep", "Oct", "Nov", "Déc"];
